import { Button, Card, Form, Spin, Tabs, List, Badge, Tag, Icon, message, Divider } from 'antd';
import React, { Component } from "react";
import { sanitizeFieldName } from "../../util/methods";
import { DndProvider, DragSource, DropTarget } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import AddDetails from "./addItem";
import * as _ from 'lodash';
import { v4 as uuidv4 } from 'uuid';
import AssetCode from "./assetCode";
import { updateTabPriority } from "../../appRedux/actions";
import { history } from "../../appRedux/store";

import Swal from 'sweetalert2';

const { TabPane } = Tabs;

class TabNode extends React.Component {
  render() {
    const { connectDragSource, connectDropTarget, children } = this.props;

    return connectDragSource(connectDropTarget(children));
  }
}

const cardTarget = {
  drop(props, monitor) {
    const dragKey = monitor.getItem().index;
    const hoverKey = props.index;

    if (dragKey === hoverKey) {
      return;
    }
    props.moveTabNode(dragKey, hoverKey);
    monitor.getItem().index = hoverKey;
  },
};

const cardSource = {
  beginDrag(props) {
    return {
      id: props.id,
      index: props.index,
    };
  },
};

const WrapTabNode = DropTarget('DND_NODE', cardTarget, connect => ({
  connectDropTarget: connect.dropTarget(),
}))(
  DragSource('DND_NODE', cardSource, (connect, monitor) => ({
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging(),
  }))(TabNode),
);

class DraggableTabs extends React.Component {
  state = {
    order: [],
  };

  moveTabNode = (dragKey, hoverKey) => {
    const newOrder = this.state.order.slice();
    const { children } = this.props;

    React.Children.forEach(children, c => {
      if (newOrder.indexOf(c.key) === -1) {
        newOrder.push(c.key);
      }
    });

    const dragIndex = newOrder.indexOf(dragKey);
    const hoverIndex = newOrder.indexOf(hoverKey);

    newOrder.splice(dragIndex, 1);
    newOrder.splice(hoverIndex, 0, dragKey);

    this.setState({
      order: newOrder,
    });

    // console.log(this.props.tabList)
    // console.log(dragKey, hoverKey);
    if (this.props.updateTabPriorityLocal) {
      // this.props.updateTabPriority(dragKey, hoverKey);
      this.props.updateTabPriorityLocal(dragKey, hoverKey);
    }
  };

  renderTabBar = (props, DefaultTabBar) => (
    <DefaultTabBar {...props}>
      {node => (
        <WrapTabNode key={node.key} index={node.key} moveTabNode={this.moveTabNode}>
          {node}
        </WrapTabNode>
      )}
    </DefaultTabBar>
  );

  render() {
    const { order } = this.state;
    const { children } = this.props;

    const tabs = [];
    React.Children.forEach(children, c => {
      tabs.push(c);
    });

    const orderTabs = tabs.slice().sort((a, b) => {
      const orderA = order.indexOf(a.key);
      const orderB = order.indexOf(b.key);

      if (orderA !== -1 && orderB !== -1) {
        return orderA - orderB;
      }
      if (orderA !== -1) {
        return -1;
      }
      if (orderB !== -1) {
        return 1;
      }

      const ia = tabs.indexOf(a);
      const ib = tabs.indexOf(b);

      return ia - ib;
    });

    return (
      <DndProvider backend={HTML5Backend}>
        <Tabs type="card" animated renderTabBar={this.renderTabBar} {...this.props}>
          {orderTabs}
        </Tabs>
      </DndProvider>
    );
  }
}

const defaultTabs = [
  {
    name: 'location', priority: 1, grammar: 'in', details: []
  },
  // {
  //   name: 'subLocation', priority: 2, grammar: 'in', details: []
  // },
  {
    name: 'assetCategory', priority: 2, grammar: 'under', details: []
  },
  {
    name: 'assetType', priority: 3, grammar: 'under', details: []
  },
  {
    name: 'assetSubType', priority: 4, grammar: 'under', details: []
  },
  {
    name: 'assetMake', priority: 5, grammar: 'under', details: []
  },
  {
    name: 'assetModel', priority: 6, grammar: 'under', details: []
  },
  {
    name: 'owner', priority: 7, grammar: 'owned by', details: []
  },
  {
    name: 'assetCode', priority: 8, grammar: 'having code', details: []
  },
];

class Create extends React.Component {
  unblock;
  state = {
    managerDetails: [],
    hasUnsavedData: false,
  }

  componentDidMount() {
    const { match, fetch, data } = this.props;
    if (match.params && match.params.id) {
      fetch(match.params.id);
    }
    // console.log('did mount')
    if (data) {
      this.setState({
        managerDetails: data
      })
    }

    this.unblock = history.block(this.handleBeforeUnload);
  }

  componentWillReceiveProps(nextProps, nextContext) {
    // console.log(nextProps.data, this.props.data);
    if (nextProps && this.props && nextProps.data && JSON.stringify(nextProps.data) !== JSON.stringify(this.props.data)) {
      // console.log('datas')
      this.setState({
        managerDetails: nextProps.data
      })
    } else if (!nextProps.data || !nextProps.data.length) {
      // console.log('default')
      const prevData = this.state.managerDetails;
      // console.log(prevData)
      if (!prevData || !prevData.length) {
        this.setState({
          managerDetails: defaultTabs
        })
      }
    }
    // else if (JSON.stringify(nextProps.data) === JSON.stringify(this.props.data)) {
    //   this.setState({
    //     managerDetails: nextProps.data
    //   })
    // }
  }

  handleBeforeUnload = (location, action) => {
    if (this.state.hasUnsavedData) {
      return 'You have unsaved changes. Are you sure you want to leave?';
    }
    return true;
  };

  componentWillUnmount() {
    if (this.unblock) {
      this.unblock();
    }
  }

  handleSubmit = (e) => {
    const { match } = this.props;
    e.preventDefault();
    const values = this.state.managerDetails;
    if (values && JSON.stringify(values) !== '{}') {
      if (match.params && match.params.id) {
        this.props.onSubmit(values, match.params.id);
      } else {
        this.props.onSubmit(values);
      }
      this.setState({
        hasUnsavedData: false
      })
    }
  };

  updateTabPriorityLocal = (source, destination) => {

    const newOrder = this.moveItemInStack(this.state.managerDetails, source, destination);
    this.setState({
      managerDetails: newOrder
    })
    this.props.updateTabPriority(source, destination);
  }

  moveItemInStack = (stack, currentPosition, targetPosition) => {
    if (
      currentPosition < 1 ||
      currentPosition > stack.length ||
      targetPosition < 1 ||
      targetPosition > stack.length + 1 ||
      currentPosition === targetPosition
    ) {
      console.log(`Invalid positions: ${currentPosition} and ${targetPosition}.`);
      return stack;
    }

    // Pop the item from the current position
    const poppedItem = stack.splice(currentPosition - 1, 1)[0];
    // console.log(`Popped item from position ${currentPosition}:`, poppedItem);

    // Add the popped item back to the target position
    stack.splice(targetPosition - 1, 0, poppedItem);
    // console.log(`Added item back to position ${targetPosition}:`, poppedItem);

    // Update priorities of remaining items
    stack.forEach((item, index) => {
      item.priority = index + 1;
    });
    return stack;
  }

  handleAdd = (newDetail) => {
    if (newDetail.name !== 'location') {
      newDetail.subValue = ''
    } else {
      if (newDetail.subValue === '') {
        return
      }
    }
    const managerDetails = _.cloneDeep(this.state.managerDetails);
    // console.log(managerDetails);
    // console.log(newDetail)
    let namedTab = managerDetails.filter(doc => doc.name === newDetail.name);
    const nonNamedTab = managerDetails.filter(doc => doc.name !== newDetail.name);

    if (!namedTab || !namedTab.length) {
      namedTab = [{
        id: uuidv4(),
        name: newDetail.name,
        priority: 1,
        details: []
      }]
    }
    const newTab = { ...namedTab[0] };
    const existingData = newTab.details.filter(d => (!d.hasOwnProperty('value') && newDetail.value === 0) ||
      (d.hasOwnProperty('value') && d.value !== '' && d.value === newDetail.value))
    const existingSubData = newTab.details.filter(d => (!d.hasOwnProperty('subValue') && newDetail.subValue === 0) ||
      (d.hasOwnProperty('subValue') && d.subValue !== '' && d.subValue === newDetail.subValue))
    // console.log(existingData);
    // console.log(existingSubData);
    if (!existingData || !existingData.length) {
      // console.log(nonNamedTab);
      // console.log(newDetail);
      newTab.details.push({ ...newDetail, id: uuidv4() });
      // console.log(newTab);
      this.setState({
        managerDetails: [...nonNamedTab, newTab],
        hasUnsavedData: true,
      });
    } else {
      // console.log(newDetail.name);
      // console.log(existingSubData);
      if (newDetail.name === 'location' && ((existingData && existingData.length) && (existingSubData && existingSubData.length))) {
        Swal.fire({
          title: 'Rule already exist. Do you want to replace ?',
          showDenyButton: true,
          showCancelButton: true,
          confirmButtonText: 'Yes',
          denyButtonText: 'No',
          customClass: {
            actions: 'my-actions',
            cancelButton: 'order-1 right-gap',
            confirmButton: 'order-2',
            denyButton: 'order-3',
          },
        }).then((result) => {
          if (result.isConfirmed) {
            const replacedTabDetails = newTab.details.filter(d => d.value !== newDetail.value && d.subValue !== newDetail.subValue)
            replacedTabDetails.push({ ...newDetail, id: uuidv4() });
            newTab.details = replacedTabDetails;
            this.setState({
              managerDetails: [...nonNamedTab, newTab],
              hasUnsavedData: true,
            });
            // Swal.fire('Saved!', '', 'success')
          }
        })
        // message.error(`Already exist !`)
      } else if (newDetail.name !== 'location' && (existingData && existingData.length)) {
        Swal.fire({
          title: 'Rule already exist. Do you want to replace ?',
          showDenyButton: true,
          showCancelButton: true,
          confirmButtonText: 'Yes',
          denyButtonText: 'No',
          customClass: {
            actions: 'my-actions',
            cancelButton: 'order-1 right-gap',
            confirmButton: 'order-2',
            denyButton: 'order-3',
          },
        }).then((result) => {
          if (result.isConfirmed) {
            const replacedTabDetails = newTab.details.filter(d => d.value !== newDetail.value)
            replacedTabDetails.push({ ...newDetail, id: uuidv4() });
            newTab.details = replacedTabDetails;
            this.setState({
              managerDetails: [...nonNamedTab, newTab],
              hasUnsavedData: true,
            });
            // Swal.fire('Saved!', '', 'success')
          }
        })
      } else {
        // console.log(nonNamedTab);
        // console.log(newDetail);
        newTab.details.push({ ...newDetail, id: uuidv4() });
        this.setState({
          managerDetails: [...nonNamedTab, newTab],
          hasUnsavedData: true,
        });
      }
    }
  };

  handleRemoveList = (name, id) => {
    // console.log(name, id)
    const managerDetails = _.cloneDeep(this.state.managerDetails);

    let namedTab = managerDetails.filter(doc => doc.name === name);
    const nonNamedTab = managerDetails.filter(doc => doc.name !== name);

    let newTab = { ...namedTab[0] };
    newTab.details = newTab.details.filter(t => t.id !== id);
    this.setState({
      managerDetails: [...nonNamedTab, newTab],
      hasUnsavedData: true
    });
  }

  render() {
    const { getFieldDecorator } = this.props.form;
    const { loading, filters, title, resource, form } = this.props;

    let managerDetails = _.cloneDeep(this.state.managerDetails);

    const locations = this.props.authUser && this.props.authUser.locations;
    const clients = this.props.authUser && this.props.authUser.clients;
    const manpowers = filters.manpower && filters.manpower.data && filters.manpower.data.data || [];
    const categories = filters.category && filters.category.data && filters.category.data.data || [];
    const types = filters.type && filters.type.data && filters.type.data.data || [];
    const subTypes = filters.subType && filters.subType.data && filters.subType.data.data || [];
    const makes = filters.make && filters.make.data && filters.make.data.data || [];
    const models = filters.model && filters.model.data && filters.model.data.data || [];
    const owners = filters.owner && filters.owner.data && filters.owner.data.data || [];
    const assets = filters.asset && filters.asset.data && filters.asset.data.data || [];

    const details = managerDetails.map(det => {
      det.details = det.details.map(doc => {
        if (doc.manager) {
          const mg = (manpowers || []).filter(mr => doc.manager === mr._id);
          if (mg && mg.length) {
            doc.manager = mg[0].name;
          }
        } else {
          doc.manager = '';
        }
        return doc;
        // return {...doc, value: loc && loc.length && loc[0] || doc.value}
      })
      // return {...det, details: ld};
      switch (det.name) {
        case 'location':
          det.details = det.details.map(doc => {
            const loc = locations && locations.filter(l => l._id === doc.value);
            doc.value = loc && loc.length && loc[0].name || (doc.value || 'All');

            const cli = clients.filter(l => l._id === doc.subValue);
            doc.subValue = cli && cli.length && cli[0].name || (doc.subValue || 'All');
            return doc;
          })
          break
        // case 'subLocation':
        //   det.details = det.details.map(doc => {
        //     const cli = clients.filter(l => l._id === doc.value);
        //     doc.value = cli && cli.length && cli[0].name || doc.value;
        //     return doc;
        //   })
        //   break
        case 'assetCategory':
          det.details = det.details.map(doc => {
            const cat = categories.filter(l => l._id === doc.value);
            doc.value = cat && cat.length && cat[0].name || (doc.value || 'All');
            return doc;
          })
          break
        case 'assetType':
          det.details = det.details.map(doc => {
            const tp = types.filter(l => l._id === doc.value);
            doc.value = tp && tp.length && tp[0].name || (doc.value || 'All');
            return doc;
          })
          break
        case 'assetSubType':
          det.details = det.details.map(doc => {
            const st = subTypes.filter(l => l._id === doc.value);
            doc.value = st && st.length && st[0].name || (doc.value || 'All');
            return doc;
          })
          break
        case 'assetMake':
          det.details = det.details.map(doc => {
            const mk = makes.filter(l => l._id === doc.value);
            doc.value = mk && mk.length && mk[0].name || (doc.value || 'All');
            return doc;
          })
          break
        case 'assetModel':
          det.details = det.details.map(doc => {
            const md = models.filter(l => l._id === doc.value);
            doc.value = md && md.length && md[0].name || (doc.value || 'All');
            return doc;
          })
          break
        case 'owner':
          det.details = det.details.map(doc => {
            const wnr = owners.filter(l => l._id === doc.value);
            doc.value = wnr && wnr.length && wnr[0].name || (doc.value || 'All');
            return doc;
          })
          break
        case 'assetCode':
          det.details = det.details.map(doc => {
            const ast = assets.filter(l => l._id === doc.value);
            doc.value = ast && ast.length && ast[0].assetCode || (doc.value || 'All');
            return doc;
          })
          break
      }
      return det;
    })
    // const sortedDetails = [...details];
    const sortedDetails = details.sort((a, b) => {
      // console.log(a)
      return a.priority - b.priority
    });

    // console.log(sortedDetails);
    return (
      <Spin spinning={loading}>
        <Card className={`gx-card-metrics`} title={<>
          <div>{title} {sanitizeFieldName(resource)} Rule</div>
          <span><Badge
            count={1}
            style={{
              backgroundColor: '#fff',
              // color: '#999',
              boxShadow: '0 0 0 1px #d9d9d9 inset'
            }}
          /><small> indicates priority</small></span></>}>
          <Form onSubmit={this.handleSubmit} layout="vertical">
            <DraggableTabs updateTabPriority={this.props.updateTabPriority}
              updateTabPriorityLocal={this.updateTabPriorityLocal}
              tabList={this.state.managerDetails}
              style={{
                border: `${this.state.hasUnsavedData ? '1px' : '0px'} solid red`,
                padding: '10px',
                borderRadius: '10px',
              }}>
              {
                sortedDetails.map(doc => {
                  doc.details.sort((a, b) => a.priority - b.priority);
                  return doc && <TabPane
                    tab={<span><Badge count={doc.priority} style={{
                      marginRight: '5px',
                      backgroundColor: '#fff',
                      color: '#999',
                      boxShadow: '0 0 0 1px #d9d9d9 inset'
                    }} animated />{sanitizeFieldName(doc.name)}</span>}
                    key={doc.priority} order={doc.priority}>
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                      <List
                        style={{ height: '35vh', overflowY: 'auto' }}
                        itemLayout="horizontal"
                        dataSource={doc.details}
                        renderItem={(item, inx) => (

                          <List.Item actions={[<a
                            onClick={() => this.handleRemoveList(doc.name, item.id)}
                            key="list-remove"><Icon type="close-square"
                              style={{ color: 'red' }} /></a>]}>
                            <List.Item.Meta
                              avatar={<Badge
                                count={(inx + 1)}
                                style={{
                                  backgroundColor: '#fff',
                                  color: '#999',
                                  boxShadow: '0 0 0 1px #d9d9d9 inset'
                                }}
                              />}
                              title={<span>All assets {doc.grammar} {doc.name}
                                <Tag style={{ marginLeft: '5px' }}
                                  color="#108ee9">{doc.name === 'assetCode' ?
                                    <AssetCode assetId={item.value}
                                      fetchedAsset={this.props.fetchedAsset}
                                      fetchAsset={this.props.fetchAsset} /> : item.value}</Tag>
                                {doc.name === 'location' ?
                                  <> and Sub Location <Tag
                                    style={{ marginLeft: '5px' }}
                                    color="#108ee9">{item.subValue}</Tag></> : null}
                                {doc.name === 'assetCode' ? 'is' : 'are'} managed by <Tag
                                  color="#2db7f5">{item.manager}</Tag></span>}
                            />
                          </List.Item>
                        )}
                      />
                      <AddDetails tabName={doc.name} grammar={doc.grammar} onAdd={this.handleAdd}
                        form={this.props.form}
                        authUser={this.props.authUser} filters={filters}
                        fetchRelationshipSearchData={this.props.fetchRelationshipSearchData}
                        assetData={this.props.assetData} loading={this.props.loading} />
                    </div>
                  </TabPane>
                })
              }
            </DraggableTabs>

            <Form.Item>
              <div style={{ display: 'flex', flexDirection: 'row' }}>
                <Button type={this.state.hasUnsavedData ? 'primary' : 'default'}
                  htmlType="submit"
                  disabled={!this.state.hasUnsavedData} loading={loading}>
                  SAVE
                </Button>
              </div>
            </Form.Item>
          </Form>
        </Card>
      </Spin>
    );
  }
}

const CreateForm = Form.create({
  name: 'global_state',
  onFieldsChange(props, changedFields) {
    props.onChange(changedFields);
  },
})(Create);

export default CreateForm;
